require('../../modules/es6.math.sign');
module.exports = require('../../modules/_core').Math.sign;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/sign.js
// module id = 1047
// module chunks = 1